module.exports = __webpack_public_path__ + "img/background_c3-2_mask.78dbc7dd.jpg";